import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

const sx = {
  height: '56px',
  borderRadius: '3px',
};

export const Placeholder = () => {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('label.loading_areas')}
      className="md:flex-1"
      sx={sx}
      disabled
    />
  );
};
